export const wait: (time: number) => Promise<void> = async (time) => new Promise((res) => setTimeout(res, time));
